<template>
  <game-template title="Jugez cette version du planning" sub-title="Cochez dans la checklist les éléments qui vous semblent être pris en compte">
    <template v-slot:content>
      <plan-game-template></plan-game-template>
    </template>
  </game-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'
import PlanGameTemplate from '../components/PlanGameTemplate'

export default {
  name: 'GamePlan2',
  mixins: [stepMixin],
  components: {
    PlanGameTemplate
  },
  mounted () {
    this.$store.commit('setPlanIndex', 1)
  }
}
</script>

<style lang="scss">

</style>
